import SignUp from "./Sign Up";
import StudentSignUp from "./Student Sign Up";
import InstructorSignUp from "./Instructor Sign Up";

export default SignUp;
export { StudentSignUp, InstructorSignUp };